<script setup >
import { onMounted, onUnmounted, ref } from 'vue'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
const props = defineProps({
  brandInfo: Object,
  extra: Object,
  color: String,
})

const isOpen = ref(false)
const toggleFrame = () => {
  isOpen.value = !isOpen.value
}
const getSingle = ()=>{
  if( props.extra.brandPMSbrandInfoImg 
    && !props.extra.brandPMSbrandInfoImg2 
    && !props.extra.brandPMSbrandInfoImg3 
    && !props.extra.brandPMSbrandInfoImg4
  ){
    return true
  } else {
    return false
  }
}
const getNumSlide = ()=>{
  let r = 0
  if(props.extra.brandPMSbrandInfoImg) r++
  if(props.extra.brandPMSbrandInfoImg2) r++
  if(props.extra.brandPMSbrandInfoImg3) r++
  if(props.extra.brandPMSbrandInfoImg4) r++
  return r
}

const createSlideArray = () => {
  let r = []
  if (props.extra.brandPMSbrandInfoImg) r.push(props.extra.brandPMSbrandInfoImg)
  if (props.extra.brandPMSbrandInfoImg2) r.push(props.extra.brandPMSbrandInfoImg2)
  if (props.extra.brandPMSbrandInfoImg3) r.push(props.extra.brandPMSbrandInfoImg3)
  if (props.extra.brandPMSbrandInfoImg4) r.push(props.extra.brandPMSbrandInfoImg4)
  return r
}

const matchIndex = ( a, b) =>{
  return ( a == b) ? true : false
}

const numSlide = ref(getNumSlide())
const slideToPlay = ref(0)
const color = props.brandInfo.brandPMSbrandColor || '#222'

let timerAction = () => {
  if( slideToPlay.value == numSlide.value - 1 ) {
    slideToPlay.value = 0
  } else {
    slideToPlay.value = slideToPlay.value + 1
  }
}
let counterInterval

onMounted(() => {
  if (typeof window !== 'undefined') {
    counterInterval = setInterval(
      timerAction, 5000)
  }
})
onUnmounted(() => { 
  if (typeof window !== 'undefined') {
    clearInterval(counterInterval)
  }
})
</script>
<template>
  <div class="brand-half-box md:grid md:grid-cols-2 gap-0 !border-b-2 !border-[#eee]">
    <div class="image-box relative aspect-square">
      <div 
        v-for="i, index in createSlideArray()"
        :key="i"
        :class="{ active: matchIndex(slideToPlay, index) }"
        class="image-wrapper"
      >
        <img
          class="slide-images absolute top-0 left-0 w-full h-full object-cover"
          :src="replaceS3path(i)"
          :alt="brandInfo.brandNameLocal"
        />
      </div>
    </div>

    <div class="text-box overflow-y-scroll md:aspect-square mb-[10px] md:mb-0 p-[calc(5vw_+_10px)] xs:p-[40px] sm:p-[60px] md:p-[10%] custom-scrollbar relative grid place-items-center" :class="{ open: isOpen }">
      <div class="w-full">
        <div class="text-frame" v-html="stripslashes(extra.brandPMSbrandInfoHTML)" />
        <div class="btn-frame">
          <button v-if="!isOpen" type="button" class="viewBtn" :style="{ 'background-color': color }" @click="toggleFrame()">続きを見る</button>
          <button v-if="isOpen" type="button" class="hideBtn" :style="{ 'background-color': color }" @click="toggleFrame()">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>
